"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateChainId = exports.validateIfLoggedIn = exports.validateConfig = exports.validateProviderType = void 0;
var store_1 = require("@celestejs/store");
var constants_1 = require("../constants");
function validateProviderType(providerType) {
  if (!providerType) throw new Error('celeste JS: providerType must be specified');
  if (!constants_1.providers[providerType]) throw new Error("celeste JS: providerType ".concat(providerType, " is not supported"));
}
exports.validateProviderType = validateProviderType;
function validateConfig(config) {
  var rpcs = config.rpcs,
    smartContracts = config.smartContracts,
    isMultichain = config.isMultichain;
  if (isMultichain === null || isMultichain === undefined) throw new Error('celeste JS: isMultichain must be specified');
  if (!rpcs) throw new Error('celeste JS: rpcs must be specified in celeste.config.js');
  if (Object.keys(rpcs).length === 0) throw new Error('celeste JS: config rpcs must contain at least one element');
  if (smartContracts) {
    if (!Array.isArray(smartContracts)) {
      throw new Error('celeste JS: smartContracts must be specified in celeste.config.js');
    }
  }
}
exports.validateConfig = validateConfig;
function validateIfLoggedIn() {
  var isLoggedIn = store_1.store.getState().walletReducer.isLoggedIn;
  if (isLoggedIn) return true;
  return false;
}
exports.validateIfLoggedIn = validateIfLoggedIn;
function validateChainId(chainId) {
  if (typeof chainId !== 'number' || chainId < 0) throw new Error('celeste JS: chainId must be a number greater than 0');
}
exports.validateChainId = validateChainId;